var make = require('./make_');
var arrFind = require('../array/find');
var objFind = require('../object/find');

    /**
     * Find value that returns true on iterator check.
     */
    module.exports = make(arrFind, objFind);





//////////////////
// WEBPACK FOOTER
// ./~/mout/collection/find.js
// module id = 1574
// module chunks = 0 1 2